module.exports = __webpack_public_path__ + "img/french75.3b78ea34.jpg";